<template>
  <section id="login">
    <div style="margin-top:100px; margin-bottom:150px; ">
      <!-- Login Form -->

      <div class="container h-100 d-flex justify-content-center;">
        <div class="login my-auto" style="margin:auto; width:400px">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>

          <transition name="slideAnim" type="animation" appear mode="out-in">
            <form
              v-if="!procesando && !ingresarOTP && !passwordOK"
              style="padding:10px; margin:30px"
            >
              <h3 style="text-align:center; padding-bottom:15px">Recuperá la contraseña</h3>

              <div class="form-group">
                <label>Usuario</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="correo"
                  aria-describedby="emailHelp"
                  placeholder="Ingresá tu usuario"
                />
              </div>
              <transition name="slideAnim" type="animation" appear mode="out-in">
                <div v-if="mensaje" class="alert alert-danger" role="alert">{{mensaje}}</div>
              </transition>

              <div style="text-align:center">
                <button type="button" class="btn boton-primario" @click="recupero()">Continuar</button>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "login",

  data() {
    return {
      pass: null,
      passC: null,
      correo: null,
      respuesta: "",
      mensaje: null,
      clave: null,
      procesando: false,
      ingresarOTP: false,
      passwordOK: false
    };
  },

  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },

  methods: {
    enviarCodigo(mail) {
      self = this;
      self.errorMessage = "";
      fetch(this.$store.state.pathAPI + "codigo.php", {
        method: "POST",
        body: "&mail=" + mail + "&tipo_codigo=OLVIDO",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "ERROR") {
              self.mensaje = result.mensaje;
            } else {
              self.$router.push({ path: "/CodigoSecreto/Olvido/" + mail });
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },

    recupero() {
      var self = this;
      self.mensaje = ""
      if (!self.correo) {
        self.mensaje = "Debés ingresar una dirección de correo electrónico";
        return;
      }
      this.enviarCodigo(self.correo);
    },

    volver() {
      this.$router.push({ path: "/Login/inicio" });
    }
  },
  components: {},

  mounted: function() {}
};
</script>

<style scoped>
#login {
  background: url("/public/images/site/background-login.svg");
  background-repeat: repeat-x;
  display: table;
  background-size: 1000px;

  width: 100%;
  background-position-y: top;
}

.olvide-password {
  margin: 15px;
  padding: 5px 20px;
  border-radius: 20px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  cursor: pointer;
  font-size: 15px;
  font-family: "Patua One", cursive;
  color: rgb(93, 93, 93);
}
.olvide-password:hover {
  transition: 0.2s;
  z-index: 1;
  color: #9546af;
}

.login {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}

.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/RecoverPassword.vue